<select name="" id="" [(ngModel)]="cellValue" (change)="changeValue()">
  <option [ngValue]="null" disabled>Select</option>
  <option *ngFor="let option of optionList" [ngValue]="option.value">{{option.name}}</option>

</select>